
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/presidentWord",
      function () {
        return require("private-next-pages/[lang]/presidentWord.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/presidentWord"])
      });
    }
  